import { objectValidation } from "@domains/utils/validation";
export var GetThirdPartyPOADetailsMapper = function (data) {
    var clientThirdPartyPOA = objectValidation({
        acCode: data.acCode,
        thirdParty_NAME: data.thirdParty_NAME,
        relation: data.relation !== null ? data.relation : "",
        comments: data.comments,
        panno: data.panno,
        email: data.email,
        fileName: data.fileName,
        data: data.data !== null ? data.data : "",
        acName: data.acName,
        eqbse: data.eqbse,
        eqnse: data.eqnse,
        eqmsei: data.eqmsei,
        fobse: data.fobse,
        fonse: data.fonse,
        fomsei: data.fomsei,
        currencybse: data.currencybse,
        currencynse: data.currencynse,
        currencymsei: data.currencymsei,
        mcx: data.mcx,
        ncdex: data.ncdex,
        neml: data.neml,
        mobileNo: data.mobileNo,
        poaFiles: data.databytes,
    });
    return clientThirdPartyPOA;
};
